// extracted by mini-css-extract-plugin
export default {"main":"KeyIdBadge_main__FOej5"};